import moment from 'moment';
import {prune} from 'underscore.string';
import {getSeoDescription} from 'src/utils/parserHTML';
import linkUtils from 'src/utils/linkUtils';
import i18n from 'i18next';

const isServer = typeof window === 'undefined';
const testStartDate = new Date('2016-08-09 09:00');
const testEndDate = new Date('2016-08-09 12:00');

export const shouldIndexPost = post => {
  const dateCreated = new Date(post.dateCreated);
  const isInTestWindow = testStartDate < dateCreated && dateCreated < testEndDate;
  const isInScreeningPeriod = moment().subtract(24, 'hours').isBefore(moment(post.dateCreated));
  return !post.isPrivate && !(isInTestWindow && isInScreeningPeriod) && (post.totalResponses > 1 || post.body && post.body.length > 60);
};

export const getPostSeo = (post = {}, community = {}) => {
  return {
    // TODO replace hardcoded url with an environment variable.
    canonical: `https://healthunlocked.com/${community.slug}/posts/${post.id}/${post.urlEncodedTitle}`,
    published_time: post.dateCreated,
    modified_time: post.dateLastActivity,
    title: `${post.title} - ${community.name} | HealthUnlocked`,
    description: prune(getSeoDescription(post.enriched.body || []), 200),
    image: community.logoImageHash ? linkUtils.generateGroupImageUrl(community.logoImageHash) : null,
    robots: shouldIndexPost(post) ? 'index, follow' : 'noindex, follow',
  };
};

export const getCommunitySeo = (community = {}) => {
  if (!community) return {};
  return {
    canonical: `https://healthunlocked.com/${community.slug}`,
    title: `${community.name} | HealthUnlocked`,
    description: community.description,
    image: linkUtils.generateGroupImageUrl(community.logoImageHash),
    robots: 'index',
  };
};

export const getCommunityPostsSeo = (community = {}, communityTopTags = {}) => {
  if (!community) return {};
  let description = 'Read community conversations. Get support and information from people sharing their experiences';
  if (communityTopTags.length) {
    description += ' with' + communityTopTags.map(tag => tag.name.toLowerCase()).map(tagName => ` ${tagName}`) + ' and more.';
  }
  return {
    canonical: `https://healthunlocked.com/${community.slug}/posts`,
    title: `Posts - ${community.name} | HealthUnlocked`,
    description: description,
    image: linkUtils.generateGroupImageUrl(community.logoImageHash),
    robots: 'index',
  };
};

export const getArticleSeo = (title, snippet, imageUrl, articleUrl) => {
  if (!title) return {};
  return {
    canonical: `https://healthunlocked.com/${articleUrl}`,
    title: `${title} | HealthUnlocked`,
    description: snippet,
    image: imageUrl,
    robots: 'index',
  };
};

export const getProgramLandingSeo = (programSlug, name, healthCategory, image, summaryDescription) => {
  return {
    canonical: `https://healthunlocked.com/programs/${programSlug}`,
    title: `${name} | ${healthCategory} | HealthUnlocked`,
    image,
    robots: 'index',
    description: summaryDescription,
  };
};

export const getProgramModuleSeo = (moduleTitle, moduleCode, name, programSlug, currentModule) => {
  let description = '';
  if (currentModule.sections) {
    description = currentModule.sections[0].content.trim().split(/\r?\n/)[0];
  }
  return {
    canonical: `https://healthunlocked.com/programs/${programSlug}/${moduleCode}`,
    title: `${moduleTitle} | ${name} | HealthUnlocked`,
    robots: 'index',
    description,
  };
};


export const getResourceSeo = (resourceId, name, image, description) => {
  return {
    canonical: `https://healthunlocked.com/resources/${resourceId}`,
    title: `${name} | HealthUnlocked`,
    image,
    meta: { robots: 'index' },
    description,
  };
};

export const getTagsPageSeo = (tagId, pageType, title) => {
  return {
    canonical: `https://healthunlocked.com/${pageType}/${tagId}`,
    title: i18n.t('%1s questions, tips and experiences | HealthUnlocked').replace('%1s', title.trim()),
    description: i18n.t('Learn about %1s. Find tips and advice, ask experienced people questions and read their insights on treatments and symptoms.').replace('%1s', title.trim()),
  };
};

export const isUserBot = !isServer && /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);



// WEBPACK FOOTER //
// ./src/utils/seo.js